/*
  Coupon price on the PDP.
  When the visitor arrives with a discount code (/discount/CODE?redirect=... sets the
  `discount_code` cookie; ?discount=CODE is also accepted), the code is evaluated for the
  selected variant through the Storefront API using a throw-away cart (no analytics events,
  the shopper's real cart is untouched) and the existing price + sale badge are rewritten
  in place. No nodes are added, so the layout height never changes.
  If the code is invalid or not applicable, nothing is touched.
*/
(function () {
  if (window.__skinupCouponPriceLoaded) return;
  window.__skinupCouponPriceLoaded = true;

  var instances = window.SkinUpCouponPrice;
  if (!instances || !instances.length) return;
  var cfg = instances[0];

  var url = new URL(window.location.href);
  var code = url.searchParams.get('discount') || url.searchParams.get('discount_code') || '';
  var fromUrl = !!code;
  if (!code) {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (m) code = decodeURIComponent(m[1]);
  }
  code = (code || '').trim();
  if (!code) return;

  // Keep checkout honest: a code arriving as a plain URL param is attached to the real cart
  // the same way the theme's own discount field does it.
  if (fromUrl && cfg.applyFromUrl) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).catch(function () {});
  }

  var API = '/api/2025-07/graphql.json';
  var QUERY =
    'mutation cp($lines:[CartLineInput!]!,$codes:[String!]){' +
    ' cartCreate(input:{lines:$lines,discountCodes:$codes}){' +
    '  cart{ discountCodes{ code applicable } discountAllocations{ discountedAmount{ amount } }' +
    '   lines(first:1){ nodes{ cost{ subtotalAmount{ amount } } discountAllocations{ discountedAmount{ amount } } } } }' +
    '  userErrors{ message } } }';

  function toCents(amount) { return Math.round(parseFloat(amount) * 100); }

  function formatMoney(cents, format) {
    var value = cents / 100;
    var thousands = ',', decimal = '.', decimals = 2;
    var token = (format.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
    if (token.indexOf('no_decimals') !== -1) decimals = 0;
    if (token.indexOf('comma_separator') !== -1) { thousands = '.'; decimal = ','; }
    if (token.indexOf('space_separator') !== -1) { thousands = ' '; decimal = decimals ? (token.indexOf('period') !== -1 ? '.' : ',') : ''; }
    if (token.indexOf('apostrophe_separator') !== -1) { thousands = "'"; decimal = '.'; }
    var fixed = value.toFixed(decimals);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var number = decimals ? parts[0] + decimal + parts[1] : parts[0];
    return format.replace(/\{\{\s*\w+\s*\}\}/, number);
  }

  function cacheKey(variantId) { return 'cp:' + code.toUpperCase() + ':' + variantId; }

  function evaluate(variantId) {
    var key = cacheKey(variantId);
    try {
      var hit = sessionStorage.getItem(key);
      if (hit) return Promise.resolve(JSON.parse(hit));
    } catch (e) {}

    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: QUERY,
        variables: {
          lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: 1 }],
          codes: [code]
        }
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var cart = json && json.data && json.data.cartCreate && json.data.cartCreate.cart;
        var result = { applicable: false };
        if (cart && cart.lines && cart.lines.nodes.length) {
          var line = cart.lines.nodes[0];
          var subtotal = toCents(line.cost.subtotalAmount.amount);
          var saved = 0;
          (line.discountAllocations || []).forEach(function (a) { saved += toCents(a.discountedAmount.amount); });
          (cart.discountAllocations || []).forEach(function (a) { saved += toCents(a.discountedAmount.amount); });
          var codeOk = (cart.discountCodes || []).some(function (c) {
            return c.applicable && c.code.toUpperCase() === code.toUpperCase();
          });
          if (codeOk && saved > 0 && saved < subtotal) {
            result = { applicable: true, original: subtotal, discounted: subtotal - saved };
          }
        }
        try { sessionStorage.setItem(key, JSON.stringify(result)); } catch (e) {}
        return result;
      })
      .catch(function () { return { applicable: false }; });
  }

  function currentVariantId(instance) {
    var section = document.getElementById('shopify-section-' + instance.sectionId);
    var input = section && section.querySelector('form[action*="/cart/add"] input[name="id"]');
    var live = new URL(window.location.href).searchParams.get('variant');
    return (live || (input && input.value) || instance.firstVariantId) + '';
  }

  var applying = false;

  // Replace the badge copy but keep any icon the merchant configured in it.
  function setBadgeText(el, text) {
    Array.prototype.slice.call(el.childNodes).forEach(function (node) {
      var isIcon = node.nodeType === 1 && (node.matches('svg, img, .material-icon, .icon, [class*="icon"]') || node.querySelector('svg, img'));
      if (!isIcon) el.removeChild(node);
    });
    el.appendChild(document.createTextNode(text));
  }

  function apply(instance, variantId, result) {
    var root = document.getElementById('price-' + instance.sectionId);
    if (!root || !result.applicable) return;
    var variant = instance.variants[variantId];
    var base = variant && variant.compare_at > variant.price ? variant.compare_at : result.original;
    var pct = Math.floor((base - result.discounted) * 100 / base);
    var text = formatMoney(result.discounted, instance.moneyFormat);

    // Idempotent: only touch nodes whose text differs, so our own mutations never re-trigger the observer.
    var changed = false;
    applying = true;
    root.querySelectorAll('.main-price').forEach(function (el) {
      if (el.textContent.trim() !== text) { el.textContent = text; changed = true; }
    });
    var badge = root.querySelector('.price__badge-sale .nowrap, .price__badge-custom');
    if (badge) {
      var template = code.length > instance.codeMaxLength ? instance.badgeTextShort : instance.badgeText;
      var badgeText = template.replace('[percentage]', pct).replace('[code]', code.toUpperCase());
      if (badge.textContent.trim() !== badgeText) { setBadgeText(badge, badgeText); changed = true; }
    }
    root.classList.add('coupon-price--active');
    if (instance.pulse && changed) {
      root.classList.remove('coupon-price--pulse');
      void root.offsetWidth;
      root.classList.add('coupon-price--pulse');
    }
    applying = false;
  }

  function run(instance) {
    var variantId = currentVariantId(instance);
    evaluate(variantId).then(function (result) {
      // the variant may have changed while the request was in flight
      if (currentVariantId(instance) !== variantId) return;
      apply(instance, variantId, result);
    });
  }

  instances.forEach(function (instance) {
    var root = document.getElementById('price-' + instance.sectionId);
    if (!root) return;
    run(instance);

    // The theme re-renders the price block on variant change; re-apply after it settles.
    var timer = null;
    var schedule = function () {
      if (applying) return;
      clearTimeout(timer);
      timer = setTimeout(function () { run(instance); }, 80);
    };
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input, [data-variant-picker]')) schedule();
    });
    window.addEventListener('popstate', schedule);
  });
})();
